import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PersonalDetail from "./PersonalDetail/PersonalDetail";
import AddressIdentification from "./AddressIdentification/AddressIdentification";
import FilmsDetails from "./FilmsDetails/FilmsDetails";
import Declaration from "./Declaration/Declaration";
import Preview from "./CmotPreview/Preview";
import "./cmotStyle.css";
import { Container } from "@mui/material";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
// import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import logo from "../../assets/images/IFFFI_LOGO.png";
import logo1 from "../../images/ashok-logo.png";
import logo2 from "../../assets/images/NFDC-Logo.png";
import { postRequest, getRequest } from "../../API/IP";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

import { validateEmail } from "../Helper";
import CmotSubmission from "./CmotSubmission/CmotSubmission";
import { calculateAge } from "../Helper";
import Loader from "../common/Loader/Loader";

const steps = [
  "Personal Detail",
  "Address & Identification",
  "Films Details",
  "Preview",
  "Declaration ",
  "Submission",
];

const CmotStepperData = () => {
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const { id = null, ip_step = 1 } = useParams();
  // console.log({ id });
  const [preData, setPredata] = useState({});
  const [formData, setFormData] = useState({
    film_duration: dayjs().startOf("day"), // Initialize with a valid dayjs object
  });
  const navigate = useNavigate();
  const [completed, setCompleted] = useState({});

  const [personalDetailsErrors, setPersonalDetailErrors] = useState({});
  const [addressDetailsErrors, setAddressDetailsErrors] = useState({});
  const [filmDetailsErrors, setFilmDetailsErrors] = useState({});
  const [declarationErrors, setDeclarationErrors] = useState({});
  const dashboardnavi = useNavigate();

  const verifyExistingRecord = async () => {
    if (id) return true;

    const predata = await getRequest("cmot");
    const data = predata?.data;
    if (data.length >= 1) {
      alert("You have reached maximum limit.");
      dashboardnavi("/dashboard");
    }
  };

  const loadpreData = async () => {
    if (id) {
      try {
        const predata = await getRequest(`cmot/${id}`, {});

        const loadpredata = predata.data;
        if (loadpredata.step == 5) {
          //  navigate(`/cmot/view/${id}`);
        }

        setActiveStep(loadpredata.step);
        const documentData = {};
        if (loadpredata.documents) {
          for (const document of loadpredata.documents) {
            if (document.type == 1) loadpredata.is_first_gov_id_proof = 1;
            else if (document.type == 2) loadpredata.is_second_gov_id_proof = 1;
            else if (document.type == 3) loadpredata.is_upload_cv = 1;
            else if (document.type == 4) loadpredata.is_upload_reel = 1;
            else if (document.type == 5) loadpredata.is_passport_photo = 1;
            else if (document.type == 6) loadpredata.film_duration = 1;

            documentData[document.type] = {
              file: document.file,
              name: document.name,
            };
          }
        }
        loadpredata.documentData = documentData;
        setFormData({
          ...loadpredata,
        });
        setPredata(predata.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Hide loader
      }
    }
  };

  // Show modal when component mounts
  useEffect(() => {
    verifyExistingRecord(); // Ensure this function is defined and working correctly
    loadpreData();
    const data = preData.data;
    setPredata(data);

    setActiveStep(parseInt(ip_step - 1));
  }, []);

  const [openDialog, setOpenDialog] = useState(false);
  // const [dialogAction, setDialogAction] = useState(null);

  const dialogAction = useRef(null);

  const handleDialogClose = async (confirm) => {
    setOpenDialog(false);
    if (confirm && dialogAction.current) {
      await dialogAction.current();
    }
  };

  const handleComplete = async () => {
    const newCompleted = { ...completed };
    newCompleted[activeStep] = true;
    // handleNext();
    // scrollUp()
    // console.log('Starting handleComplete with activeStep:', activeStep, 'and id:', id);
    // Validate current step data
    // let isValid = true;

    // step 1 Personal Detail

    setLoading(true);
    // Simulate an async operation (e.g., API call)

    if (activeStep === 0) {
      const { isValidPersonal, errorsPersonal } =
        validatePersonalDetails(formData);
      if (!isValidPersonal) {
        setLoading(false);
        setPersonalDetailErrors(errorsPersonal);
        return;
      }

      try {
        if (id) {
          formData["last_id"] = id;
        }
        const response = await postRequest("cmot", { ...formData, step: 1 });
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (response.status) {
          navigate(`/cmot/${response.data.id}/`);
          setActiveStep(1);
        } else {
          const serverErrors = response.data || {};
          // Trim keys in the server error object
          const trimmedServerErrors = Object.keys(serverErrors).reduce(
            (acc, key) => {
              acc[key.trim()] = serverErrors[key];
              return acc;
            },
            {}
          );

          setPersonalDetailErrors((prevErrors) => ({
            ...prevErrors,
            ...trimmedServerErrors,
          }));

          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 2 Address & Identification
    if (activeStep === 1) {
      const { isValidAddress, errorsAddrerss } =
        validateAddressDetails(formData);
      // console.log(errorsAddrerss)
      if (!isValidAddress) {
        setAddressDetailsErrors(errorsAddrerss);
        setLoading(false);
        return; // Stop execution if validation fails
      }
      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 2,
        last_id: id,
      };
      // console.log({ updatedFormData });

      try {
        const cmot_details_check = await postRequest("cmot", updatedFormData);
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
          //navigate(`/ip/${id}/2`);
          // setActiveStep(2);
        } else {
          alert(cmot_details_check.message);
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 3 Films Details
    if (activeStep === 2) {
      // Validation for the Director Details step
      const { isValidFilm, errorsFilm } = validateFilmDetails(formData);
      // console.log(isValidFilm, "isValidFilm")
      // console.log(errorsFilm)
      if (!isValidFilm) {
        setLoading(false);
        setFilmDetailsErrors(errorsFilm);
        return;
      }

      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 3,
        last_id: id,
      };

      try {
        const cmot_details_check = await postRequest("cmot", updatedFormData);
        // console.log(cmot_details_check);
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
        } else {
          alert(cmot_details_check.message);
          return 0;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 4 Preview
    if (activeStep === 3) {
      const updatedFormData = {
        step: 4,
        last_id: id,
      };
      try {
        const cmot_details_check = await postRequest("cmot", updatedFormData);
        setTimeout(() => {
          setLoading(false); // Set loading to false once the operation is complete
        }, 1000);
        if (cmot_details_check.status) {
          handleNext();
        } else {
          alert(cmot_details_check.message);
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // step 5 Declaration
    if (activeStep === 4) {
      const { isValidDeclaration, errorsDeclaration } =
        validateDeclarationDetails(formData);
      // console.log({ isValidDeclaration });
      if (!isValidDeclaration) {
        setLoading(false);
        setDeclarationErrors(errorsDeclaration);
        return;
      }
      if (!id) {
        console.error("ID is not available.");
        return;
      }

      dialogAction.current = async () => {
        const updatedFormData = { ...formData, step: 5, last_id: id };
        try {
          setLoading(true);
          const cmot_details_check = await postRequest("cmot", updatedFormData);
          setTimeout(() => {
            setLoading(false); // Set loading to false once the operation is complete
          }, 500);
          if (cmot_details_check.status) {
            handleNext();
          } else {
            alert(cmot_details_check.message);
          }
        } catch (error) {
          console.error("Error:", error);
        }
      };
      setLoading(false);
      setOpenDialog(true);
    }

    // setCompleted(newCompleted);
    if (activeStep === steps.length - 1) {
    } else {
      // Check if the next step is not completed before proceeding
      if (!isStepCompleted(activeStep + 1)) {
      }
    }
    await loadpreData();
  };

  const handleNext = async () => {
    // setActiveStep((prevActiveStep) => prevActiveStep + 1);

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepCompleted = (step) => {
    return completed[step];
  };

  const handleSubmit = () => {
    // Placeholder function for form submission logic
    <Alert
      variant="filled"
      icon={<CheckIcon fontSize="inherit" />}
      severity="success"
    >
      Your Form is Success fully submitted
    </Alert>;
  };
  // Ensure formData.film_duration is a dayjs object or convert it if needed
  const getFilmDuration = (duration) => {
    if (dayjs.isDayjs(duration)) {
      return duration.format("mm:ss");
    }
    return dayjs(duration).format("mm:ss");
  };

  const renderStepContent = (step) => {
    // Render different step components based on activeStep
    switch (step) {
      case 0:
        return (
          <PersonalDetail
            formData={formData}
            setFormData={setFormData}
            errors={personalDetailsErrors}
            setPersonalDetailErrors={setPersonalDetailErrors}
            handleComplete={handleComplete}
          />
        );
      case 1:
        return (
          <AddressIdentification
            formData={formData}
            setFormData={setFormData}
            errors={addressDetailsErrors}
            setAddressDetailsErrors={setAddressDetailsErrors}
          />
        );
      case 2:
        return (
          <FilmsDetails
            formData={formData}
            setFormData={setFormData}
            errors={filmDetailsErrors}
            setFilmDetailsErrors={setFilmDetailsErrors}
            filmDuration={getFilmDuration(formData.film_duration)}
          />
        );
      case 3:
        return <Preview formData={formData} />;
      case 4:
        return (
          <Declaration
            formData={formData}
            setFormData={setFormData}
            errors={declarationErrors}
            setDeclarationErrors={setDeclarationErrors}
          />
        );
      case 5:
        return <CmotSubmission />;
      default:
        return "Unknown step";
    }
  };

  const validatePersonalDetails = (formData, serverErrors = {}) => {
    const {
      is_passport_photo,
      name,
      dob,
      gender,
      other_gender,
      contact_number,
      is_upload_cv,
      email,
      bio,
      reason_to_join,
      alternate_number,
      website_link,
      twitter_account_link,
      instagram_account_link,
      facebook_account_link,
      linkedin_account_link,
      how_you_find,
      cmot_applicant,
      scale,
      bio2,
      country_code,
      alternate_country_code,
    } = formData;
    const errorsPersonal = {};

    if (!name) {
      errorsPersonal.name = "Name is required";
    }
    if (!is_passport_photo) {
      errorsPersonal.is_passport_photo = "Passphoto is required";
    }
    if (!dob) {
      errorsPersonal.dob = "Date of Birth is required";
      errorsPersonal.age = "Date of Birth is required";
    } else {
      const calculatedAge = calculateAge(dob);
      if (calculatedAge < 18 || calculatedAge > 35) {
        errorsPersonal.dob = "Age must be between 18 and 35.";
      }
    }

    if (!gender) {
      errorsPersonal.gender = "Gender is required";
    }

    if (formData.gender === "Other") {
      if (!other_gender) {
        errorsPersonal.other_gender = "Other Gender is required";
      }
    }

    if (!contact_number) {
      errorsPersonal.contact_number = "Contact number is required";
    } else {
      if (contact_number.length < 10) {
        errorsPersonal.contact_number = "Contact number must be of 10 digits.";
      }
    }
    if (!country_code) {
      errorsPersonal.country_code = "Country Code is required";
    } else {
      if (country_code.length < 2) {
        errorsPersonal.country_code = "Country Code is required";
      }
    }
    if (!alternate_country_code) {
      errorsPersonal.alternate_country_code = "Country Code is required";
    } else {
      if (alternate_country_code.length < 2) {
        errorsPersonal.alternate_country_code = "Country Code is required";
      }
    }

    if (!alternate_number) {
      errorsPersonal.alternate_number = "Alternate number is required";
    } else {
      if (alternate_number.length < 10) {
        errorsPersonal.alternate_number =
          "Alternate number must be of 10 digits.";
      }
    }
    if (!email) {
      errorsPersonal.email = "Enter your email id";
    } else if (!validateEmail(email)) {
      errorsPersonal.email = "Email is not valid.";
    }

    if (!bio) {
      errorsPersonal.bio = "Bio is required";
    } else {
      const wordCount = bio.trim().split(/\s+/).length;
      if (wordCount > 200) {
        errorsPersonal.bio = "Applicant Brief Bio cannot exceed 200 words.";
      }
    }
    if (!bio2) {
      errorsPersonal.bio2 = "Details are required";
    } else {
      const wordCount = bio2.trim().split(/\s+/).length;
      if (wordCount > 200) {
        errorsPersonal.bio2 = "Details cannot exceed 200 words.";
      }
    }
    if (!website_link) {
      errorsPersonal.website_link = "Website Link";
    }
    if (!twitter_account_link) {
      errorsPersonal.twitter_account_link = "Twitter Account Link";
    }
    if (!instagram_account_link) {
      errorsPersonal.instagram_account_link = "Instagram Account Link";
    }
    if (!facebook_account_link) {
      errorsPersonal.facebook_account_link = "Facebook Account Link";
    }
    if (!linkedin_account_link) {
      errorsPersonal.linkedin_account_link = "Linkdin Account Link";
    }
    if (!how_you_find) {
      errorsPersonal.how_you_find = "How Did You Find About CMOT ?";
    }

    if (!reason_to_join) {
      errorsPersonal.reason_to_join = "Details are required";
    } else {
      const wordCount = reason_to_join.trim().split(/\s+/).length;
      if (wordCount > 200) {
        errorsPersonal.reason_to_join = "Details cannot exceed 200 words.";
      }
    }

    if (!scale) {
      errorsPersonal.scale = "Rating is required";
    }
    
    // Merge server-side errors with client-side errors
    const mergedErrors = { ...errorsPersonal, ...serverErrors };

    const isValidPersonal = Object.keys(mergedErrors).length === 0;
    return { isValidPersonal, errorsPersonal: mergedErrors };
  };

  const validateAddressDetails = (formData) => {
    const {
      address_confirmation,
      permanent_address,
      permanent_state,
      permanent_city,
      residence_address,
      residence_state,
      residence_city,
      first_govt_id_number,
      is_first_gov_id_proof,
      second_govt_id_number,
      is_second_gov_id_proof,
      // state_of_origin_id,
    } = formData;
    const errorsAddrerss = {};
    if (!permanent_address) {
      errorsAddrerss.permanent_address = "Address is required";
    }
    if (!permanent_state) {
      errorsAddrerss.permanent_state = "State/UT is required";
    }

    // if (!state_of_origin_id) {
    //   errorsAddrerss.state_of_origin_id = "State/UT of Origin is required";
    // }

    if (!permanent_city) {
      errorsAddrerss.permanent_city = "City is required";
    }

    if (!residence_address && !address_confirmation) {
      errorsAddrerss.residence_address = "residence address is required";
    }

    if (!residence_state && !address_confirmation) {
      errorsAddrerss.residence_state = "residence address is required";
    }

    if (!residence_city && !address_confirmation) {
      errorsAddrerss.residence_city = "residence city is required";
    }

    if (!first_govt_id_number) {
      errorsAddrerss.first_govt_id_number = "First govt id number is required";
    }

    if (!is_first_gov_id_proof) {
      errorsAddrerss.is_first_gov_id_proof = "First govt id proof is required";
    }

    if (!second_govt_id_number) {
      errorsAddrerss.second_govt_id_number = "Second govt id proof is required";
    }

    if (!is_second_gov_id_proof) {
      errorsAddrerss.is_second_gov_id_proof =
        "Second govt id proof is required";
    }
    const isValidAddress = Object.keys(errorsAddrerss).length === 0;

    return { isValidAddress, errorsAddrerss };
  };

  const validateFilmDetails = (formData) => {
    const {
      category_id,
      link_of_film,
      project_title,
      film_duration,
      is_upload_cv,
      filmography_url,
      is_upload_reel,
      link_film_password,
      project_completion_date,
      specialization,
    } = formData;
    const errorsFilm = {};

    if (!category_id) {
      errorsFilm.category_id = "Film Craft is required";
    }
    if (formData.category_id == 5) {
      if (!specialization) {
        errorsFilm.specialization = "Specialization is required";
      }
    } else {
    }

    if (!link_of_film) {
      errorsFilm.link_of_film = "Link of film is required";
    }
    if (!link_film_password) {
      errorsFilm.link_film_password = "Link film password is required";
    }

    if (!project_title) {
      errorsFilm.project_title = "Project title is required";
    }

    if (!project_completion_date) {
      errorsFilm.project_completion_date =
        "Project Completion date is required";
    }

    // Convert film_duration to minutes for validation
    if (film_duration) {
      // Check if the duration is in the correct format (e.g., "mm:ss")
      const durationPattern = /^\d{1,2}:\d{2}$/;
      if (!durationPattern.test(film_duration)) {
        errorsFilm.film_duration = "Film duration must be in the format mm:ss.";
      } else {
        const [minutes, seconds] = film_duration.split(":");
        // console.log("Minutes and seconds:", { minutes, seconds });

        const durationMinutes = parseInt(minutes, 10);
        const durationSeconds = parseInt(seconds, 10);
        // console.log({ durationMinutes, durationSeconds });

        if (isNaN(durationMinutes) || isNaN(durationSeconds)) {
          console.error("Invalid duration:", {
            durationMinutes,
            durationSeconds,
          });
          errorsFilm.film_duration = "The film duration must be a number.";
        } else {
          const totalDurationInSeconds = durationMinutes * 60 + durationSeconds;

          if (totalDurationInSeconds > 10 * 60) {
            errorsFilm.film_duration =
              "Film duration must be less than 10 minutes.";
          } else if (totalDurationInSeconds < 60) {
            errorsFilm.film_duration =
              "Film duration must be greater than 1 minute.";
          } else if (durationSeconds < 0 || durationSeconds >= 60) {
            errorsFilm.film_duration = "Seconds must be between 0 and 59.";
          }
        }
      }
    } else {
      errorsFilm.film_duration = "Film duration is required";
    }

    if (!is_upload_cv) {
      errorsFilm.is_upload_cv = "Upload cv is required";
    }

    if (!filmography_url) {
      errorsFilm.filmography_url = "Filmography URL is required";
    }

    if (!is_upload_reel) {
      errorsFilm.is_upload_reel = "Upload reel is required";
    }

    const isValidFilm = Object.keys(errorsFilm).length === 0;

    return { isValidFilm, errorsFilm };
  };

  const validateDeclarationDetails = (formData) => {
    const {
      declaration_tv_reserve,
      declare_right_to_short_film,
      declare_have_all_necessary_permission,
      declare_non_commercial_publicity,
      declare_for_false_informtion,
      declare_for_correct_informtion,
      confirm,
    } = formData;
    const errorsDeclaration = {};

    if (!declaration_tv_reserve) {
      errorsDeclaration.declaration_tv_reserve =
        "Declare right to short film is required";
    }
    if (!declare_right_to_short_film) {
      errorsDeclaration.declare_right_to_short_film =
        "Declare right to short film is required";
    }
    // console.log({ declare_have_all_necessary_permission });
    if (!declare_have_all_necessary_permission) {
      errorsDeclaration.declare_have_all_necessary_permission =
        "Declare have all necessary permission is required";
    }

    if (!declare_non_commercial_publicity) {
      errorsDeclaration.declare_non_commercial_publicity =
        "Declare non commercial publicity is required";
    }

    if (!declare_for_false_informtion) {
      errorsDeclaration.declare_for_false_informtion =
        "Declaration for false information is required";
    }

    if (!declare_have_all_necessary_permission) {
      errorsDeclaration.declare_have_all_necessary_permission =
        "Declare have all necessary permission is required";
    }

    if (!declare_for_correct_informtion) {
      errorsDeclaration.declare_for_correct_informtion =
        "Correct information is required";
    }

    if (!confirm) {
      errorsDeclaration.confirm = "Declaration is required";
    }

    if (
      !declaration_tv_reserve ||
      !declare_right_to_short_film ||
      !declare_have_all_necessary_permission ||
      !declare_non_commercial_publicity ||
      !declare_for_false_informtion ||
      !declare_for_correct_informtion ||
      !confirm
    ) {
      errorsDeclaration.commonError = "All declarations must be agreed upon.";
    }

    const isValidDeclaration = Object.keys(errorsDeclaration).length === 0;

    return { isValidDeclaration, errorsDeclaration };
  };

  const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[300],
    zIndex: 1,
    color: "#fff",
    width: 24,
    height: 24,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: "#1c5768",
    }),
    ...(ownerState.completed && {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: "#1c5768",
    }),
  }));

  function CustomStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <CustomStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {completed ? (
          <CheckIcon style={{ color: "white", fontSize: "20px" }} />
        ) : null}
        {active ? (
          <CheckIcon style={{ color: "white", fontSize: "20px" }} />
        ) : null}
      </CustomStepIconRoot>
    );
  }

  return (
    <>
      {/* Header section with logos */}

      <div className="">
        <div className="d-flex justify-content-between m-3 align-items-center">
          <div className="imgLogo">
            <a href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}>
              <img
                src={logo}
                alt="Logo"
                style={{ width: "140px", height: "120px" }}
              />
            </a>
          </div>
          <div className="imgLogo">
            <img
              src={logo1}
              alt="Logo"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="imgLogo">
            <img
              src={logo2}
              alt="Logo"
              style={{ width: "200px", height: "100px" }}
            />
          </div>
        </div>
        <Container>
          <div className="cmothead">
            <div className="text-center m-3">
              <h5>Creative Minds of Tomorrow</h5>
            </div>
            <div className="m-3 d-flex justify-content-between">
              <Button
                variant="outlined"
                href={process.env.REACT_APP_BASE_PREFIX + "/dashboard/cmot"}
              >
                Dashboard
              </Button>
              <Button
                variant="outlined"
                href={process.env.REACT_APP_BASE_PREFIX + "/logout"}
                color="error"
              >
                Log Out
              </Button>
            </div>
          </div>
        </Container>
      </div>
      {/* Main content section */}
      <Container>
        {loading && <Loader />} {/* Display loader when loading is true */}
        {!loading && (
          <Box sx={{ width: "100%" }}>
            {/* Stepper component to navigate through steps */}
            <Stepper activeStep={activeStep} className="comtsteper">
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Render step content based on activeStep */}
            {activeStep === steps.length ? (
              // Show submission button when on the last step
              <React.Fragment>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleSubmit} className="bttnn">
                    Submit
                  </Button>
                </Box>
              </React.Fragment>
            ) : (
              // Show current step content and navigation buttons
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  {renderStepContent(activeStep)}
                </Typography>
                <Box
                  sx={{ pb: 2, display: "flex", flexDirection: "row", pt: 2 }}
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    <ChevronLeftIcon /> Back
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleComplete} className="bttnn">
                    {/* {activeStep === steps.length - 1 ? 'Finish' : 'Next'} */}
                    {activeStep === steps.length - 1
                      ? "Finish"
                      : activeStep === 4
                      ? "Submit"
                      : "Next"}
                    <NavigateNextIcon style={{ color: "white" }} />
                  </Button>
                </Box>
              </React.Fragment>
            )}
          </Box>
        )}
      </Container>
      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => handleDialogClose(false)}>
        <DialogTitle>Are You Sure?</DialogTitle>
        <DialogContent>
          Once submitted, the form cannot be edited/resubmitted. Do you want to
          proceed?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogClose(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleDialogClose(true)} color="primary">
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CmotStepperData;
